<template>
  <div v-if='logoSetting&&logoSetting.logo_url'>
    <el-image :style='`width: ${logoSetting.width}px;height: ${logoSetting.height}px`' fit='contain'
              :src="`${logoSetting.logo_url}`"
              :alt='`平台LOGO`'  />
  </div>
</template>

<script>
export default {
  name: 'PlcLogo',
  props:{
    logoSetting:{
      type:Object
    }
  }
}
</script>

<style scoped>

</style>
